import React from 'react';
import ProtectRoute from "@/containers/protect-route";
import {IRole} from "@/types/auth-data";
import {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {apiConfig} from "@/store";
import {getSettings} from "@/api/profile/settings"
import {setSession} from "@/api/auth/session"


const Main = observer(() => {
    const {dataResponse} = apiConfig.endpoints?.getSettings
    useEffect(() => {
            setSession().finally(() =>
                getSettings()?.finally()
            );
    }, [])
    console.log(dataResponse, "main");
    return (
        <ProtectRoute roles={[IRole.Admin, IRole.User]}>
            <div> {dataResponse?.data}</div>
        </ProtectRoute>
    );
})

export default Main;